import { AdvanceProps } from '../../Pages/BalanceAdvance'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { formatDecimal } from '../../utils/withdraw-helpers'

export interface useWithdrawProps {
  fetcher: (id: string) => Promise<any>
}

export const useAdvanceRequest = (id: string | undefined, payload: AdvanceProps, code: string) => {
    const url: string = 'producer/analytics/createBalanceAdvance'
    
    const useAdvanceRequestFetcher = async () => { 
      const nWithdrawMoney = payload.totalAdvancedRequested.replace(',', '.')
      const formattedWithdrawMoney = formatDecimal(nWithdrawMoney)
      payload.totalAdvancedRequested = formattedWithdrawMoney
      return await APIDecoratorWithBaseURI().post(url,
        {
          params: {
        eventId: id,
        ...payload,
        code2FA: code
        }
      }) 
    }
    
    return {
      useAdvanceRequestFetcher
    }
}
